import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";
import { toast } from "react-hot-toast";

const useCreateUserDocument = () => {
  const mutation = useMutation(
    async (payload) => {
      const formData = new FormData();
      formData.append("userId", payload.userId);
      formData.append("notes", payload.notes);
      formData.append("documentTypeId", payload.documentTypeId);
      payload.blobDocuments.forEach((doc) =>
        formData.append("blobDocuments", doc)
      );

      return axiosClient.post("/DocumentType/UploadCertificationQualificationDocuments", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
    {
      onMutate: () => {
        toast.loading("Creating document...", { id: "create-doc" });
      },
      onSuccess: () => {
        toast.success("Document created successfully", { id: "create-doc" });
      },
      onError: (error) => {
        toast.error(
          error.response?.data?.Errors?.[0] || "Error creating document",
          { id: "create-doc" }
        );
      },
    }
  );

  return mutation;
};

export default useCreateUserDocument;
